import PropTypes from 'prop-types';
import React from 'react';

export class Catch extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_error) {
    return { hasError: true };
  }

  componentDidCatch(_error, _errorInfo) {
    // console.error(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      const { message } = this.props;
      return typeof message === 'function' ? message() : message;
    }

    return this.props.children;
  }
}
Catch.propTypes = {
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
};

export const withCatch = (Component, message) => (props) => (
  <Catch message={message}>
    <Component {...props} />
  </Catch>
);
